import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } }
};

const stagger = {
  visible: { transition: { staggerChildren: 0.08 } }
};

const Step = ({ num, title, desc }) => (
  <div className="flex gap-3">
    <div className="w-7 h-7 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-heading font-bold text-sm flex-shrink-0">
      {num}
    </div>
    <div className="pt-0.5">
      <h4 className="font-heading font-semibold text-foreground text-sm">{title}</h4>
      <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{desc}</p>
    </div>
  </div>
);

export const ProcessSection = () => {
  const steps = [
    { num: 1, title: "Review the existing product", desc: "Map every element, flow, and decision point." },
    { num: 2, title: "Map confusion points", desc: "Identify where users hesitate or feel overwhelmed." },
    { num: 3, title: "Simplify structure", desc: "Remove noise and establish clear priorities." },
    { num: 4, title: "Design what is necessary", desc: "Every element must earn its place." }
  ];

  return (
    <section id="process" className="zone-resolution section-tight border-t border-border">
      <div className="container-narrow">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} className="mb-5">
          <p className="text-[11px] font-medium text-muted-foreground tracking-wide uppercase mb-1.5">Approach</p>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-2">
            How We Work
          </h2>
          <p className="text-sm text-muted-foreground max-w-md">
            Understanding before action.
          </p>
        </motion.div>

        <motion.div 
          initial="hidden" 
          whileInView="visible" 
          viewport={{ once: true }} 
          variants={stagger}
          className="space-y-4"
        >
          {steps.map((step, i) => (
            <motion.div key={i} variants={fadeUp}>
              <Step {...step} />
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          initial="hidden" 
          whileInView="visible" 
          viewport={{ once: true }} 
          variants={fadeUp}
          className="mt-6 p-4 bg-secondary/30 rounded border border-border"
        >
          <p className="text-sm text-foreground text-center leading-relaxed">
            This audit often becomes the foundation for future design or development work.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProcessSection;
